<template>
    <v-dialog v-model="visible" persistent max-width="600px">
        <v-card>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span>
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Unidade de Medida
                </span>
                <v-spacer/>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text
                align="center"
                justify="center"
                style="height: 320px; overflow-x: auto;"
            >
                <v-row class="mt-4">
                    <v-col cols="12" sm="12">
                        <v-text-field
                            ref="abreviacao"
                            label="Abreviação"
                            v-model="form.abreviacao"
                            placeholder="ex: kg, g, un, ml"
                            hide-details
                            outlined
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field
                            label="Nome"
                            v-model="form.nome"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field
                            label="Equivalência"
                            v-model="form.quantidade"
                            placeholder="1"
                            hint="1 desta unidade equivale a quantas da menor. Ex: kg = 1000, un = 1"
                            persistent-hint
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer />
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UnidadeMedida',

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formData: {
            type: Object,
            default: Object,
        },
    },

    data: () => ({
        loading: false,
        form: {
            nome: '',
            abreviacao: '',
            quantidade: '',
        },
    }),

    mounted() {
        this.form = this.formData;
    },

    watch: {
        visible(v) {
            v && setTimeout(() => this.$refs.abreviacao && this.$refs.abreviacao.focus(), 100);
        },

        formData(value) {
            this.form = value ? JSON.parse(JSON.stringify(value)) : {};
        }
    },

    methods: {
        salvar() {
            const id = this.form.id;

            if (!this.form.abreviacao) {
                this.notify('Informe a abreviação', 'warning');
                return;
            }

            if (!this.form.nome) {
                this.notify('Informe o nome', 'warning');
                return;
            }

            if (!this.form.quantidade) {
                this.form.quantidade = 1;
            }

            if (id) {
                this.loading = true;
                this.$http.put(`unidades-medida/${id}`, this.form).then(() => {
                    this.$emit('onCadastro');
                    this.notify('Atualizado com sucesso!');
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.loading = false));
                return;
            }

            this.loading = true;
            this.$http.post('unidades-medida', this.form).then(resp => {
                this.$emit('onCadastro', resp.data.data);
                this.notify('Salvo com sucesso!');
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loading = false));
        },
    },
}
</script>

<style scoped>
.v-card {
    padding: 0 15px 0 15px;
}

.v-expansion-panel-content {
    margin-top: 16px;
}
</style>
